module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00523.80f4080d.jpg";